export enum SellType {
  Sell = 'Sell',
  Transfer = 'Transfer',
  Donate = 'Donate',
  Other = 'Other',
}
